import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Row,
  Col,
  Checkbox,
  Divider,
  Spin,
  message,
  Modal,
} from "antd";
import createInvoice from "../../functions/invoice/createInvoice";
import VatMerchantSelect from "../select/vatMerchant";
import BankCodeSelect from "../select/bankCodeSelect";
import { useLoading } from "../../context/loadingContext";
import GetCompanyInfo from "../../functions/merchant/getCompanyInfo";
import ProductTypeSelect from "../select/productType";
import { getMerchantId, getMerchantToken } from "service/storage";

const { Option } = Select;

const MerchantInvoiceAdd = ({ open, close, refresh }) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const [invoiceHasVat, setInvoiceHasVat] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const type = Form.useWatch("type", form);
  const companyRegister = Form.useWatch("companyRegister", form);
  const onFinish = async (values) => {
    console.log("Received values of form: ", values);
    console.log("merchantId", getMerchantId());
    console.log("token", getMerchantToken());
    const token = getMerchantToken();
    var payload = {
      amount: values.amount,
      phone: values.phone,
      description: values.description,
      returnUrl: "https://spay.esukh.mn/merchantInvoiceList",
      successCallback:
        "https://apispay.esukh.mn/api/v1/merchant/paymentHandler",
      invoiceItems: [
        {
          amount: values.amount,
          productTypeId: values.productTypeId,
          accountNumber: values.accountNumber,
          bankCode: values.bankCode,
          description: values.description,
          successCallback:
            "https://apispay.esukh.mn/api/v1/merchant/paymentHandler",
        },
      ],
    };
    if (invoiceHasVat) {
      payload.invoiceItems[0].vatInfo = {
        type: type,
        companyRegister: companyRegister,
        merchantRegister: values.vatRegister,
      };
    }

    showLoading();
    console.log(payload);
    const result = await createInvoice(payload, token);
    console.log(result);
    if (result) {
      message.success("Invoice created successfully");
      refresh();
      close();
    }
    hideLoading();
  };
  useEffect(() => {
    if (
      type == "B2B" &&
      companyRegister &&
      (companyRegister.length == 10 || companyRegister.length == 7)
    ) {
      isValidCompany(companyRegister);
    } else setCompanyName(null);
  }, [companyRegister]);

  const isValidCompany = async (register) => {
    const result = await GetCompanyInfo(register);
    if (result) {
      setCompanyName(result.name);
    }
  };
  const changeHasVat = (e) => {
    setInvoiceHasVat(e.target.checked);
  };

  return (
    <Modal
      title={`Мерчант нэхэмжлэл үүсгэх`}
      open={open}
      onCancel={close}
      footer={null}
    >
      <Form form={form} size="normal" layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="amount"
              label="Дүн"
              rules={[
                { required: true, message: "Please input the amount!" },
                {
                  type: "number",
                  min: 50,
                  max: 170000,
                  message: "Amount must be between 100 and 170000",
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="phone"
              label="Утас"
              rules={[
                { required: true, message: "Please input the phone number!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="accountNumber"
              label="Шилжүүлэх данс"
              rules={[
                { required: true, message: "Please input the accountNumber!" },
              ]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="bankCode"
              label="Банк"
              rules={[
                { required: true, message: "Please input the bankCode!" },
              ]}
            >
              <BankCodeSelect />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              name="productTypeId"
              label="Бүтээгдэхүүний төрөл"
              rules={[
                { required: true, message: "Please input the bankCode!" },
              ]}
            >
              <ProductTypeSelect />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="description"
          label="Тайлбар"
          rules={[{ required: true, message: "Please input the description!" }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Checkbox
          style={{ marginTop: 10 }}
          checked={invoiceHasVat}
          onChange={changeHasVat}
        >
          НӨАТ-тэй эсэх
        </Checkbox>
        {invoiceHasVat && (
          <div style={{ marginTop: 10 }}>
            <Divider orientation="left">НӨАТ-н мэдээлэл</Divider>
            <Form.Item
              name="type"
              label="Төрөл"
              rules={[
                { required: true, message: "Please select the VAT type!" },
              ]}
            >
              <Select defaultValue={null}>
                <Option value={null}>сонго</Option>
                <Option value="B2C">Хувь хүн</Option>
                <Option value="B2B">Байгууллага</Option>
              </Select>
            </Form.Item>
            {type == "B2B" && (
              <Form.Item
                name="companyRegister"
                label="НӨАТ төлөгчийн регистр"
                rules={[
                  { required: true, message: "Please input the VAT payer!" },
                ]}
              >
                <Input suffix={<span>{companyName}</span>} />
              </Form.Item>
            )}
            <Form.Item
              name="vatRegister"
              label="НӨАТ-үүсгэгч"
              rules={[{ required: true, message: "VAT creater register" }]}
            >
              <VatMerchantSelect />
            </Form.Item>
          </div>
        )}
        <Row>
          <Col span={24} style={{ marginTop: 30, textAlign: "center" }}>
            <Form.Item className="centerItem">
              <Button
                disabled={type == "B2B" && !companyName}
                type="primary"
                className="spayDefaultButton"
                htmlType="submit"
              >
                Үүсгэх
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default MerchantInvoiceAdd;
